var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumb-img rounded",class:{ 'thumb-img--active': _vm.active }},[_c('Media',_vm._g(_vm._b({attrs:{"img-class":"rounded","aspect-ratio":"1","loader":""}},'Media',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }